/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChalkboardTeacher} from '@fortawesome/pro-duotone-svg-icons';

const ClassroomIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faChalkboardTeacher} {...props} />
);

export default ClassroomIcon;
